import {formatEventOccurrenceDate, formatEventOccurrenceTime, formatMoney} from "../../../js/formatters";

export const createHorizontalEventOccurrenceElement = (json: any): HTMLElement | null => {
    const template = document.getElementById('horizontal-event-occurrence-template') as HTMLTemplateElement;
    if (!template) {
        return null
    }

    const clone = template.content.cloneNode(true) as HTMLElement;

    const eventOccurrenceLink = clone.querySelector<HTMLLinkElement>('[data-event-occurrence-path]');
    if (eventOccurrenceLink) eventOccurrenceLink.href += `/${json.event.id}?occurrence_id=${json.id}`;

    const eventTypePlaceholder = clone.querySelector('[data-event-type]');
    if (eventTypePlaceholder) eventTypePlaceholder.textContent = json.event.event_type.name;

    const occurrenceDarePlaceholder = clone.querySelector('[data-occurrence-date]');
    if (occurrenceDarePlaceholder) occurrenceDarePlaceholder.textContent = formatEventOccurrenceDate(json.occurrence_date);

    const organizerPlaceholder = clone.querySelector('[data-organizer]');
    if (organizerPlaceholder) organizerPlaceholder.textContent = [
        json.event.organizer?.last_name, json.event.organizer?.first_name, json.event.organizer?.middle_name
    ].filter(part => !!part).join(' ');

    const infoPlaceholder = clone.querySelector('[data-occurrence-info]');
    if (infoPlaceholder) infoPlaceholder.textContent = [
        json.event.sport.name,
        json.event.location?.metro_stations?.length ? `м. ${json.event.location.metro_stations}` : null,
        json.event.participants_levels.map((pl: { name: string }) => pl.name).join("/"),
        formatEventOccurrenceTime(json.event.start_time, json.event.end_time),
        json.event.participants_type?.name,
    ].filter(part => !!part).join(" • ");

    const minCostPlaceholder = clone.querySelector('[data-min-cost]');
    if (minCostPlaceholder) minCostPlaceholder.textContent = formatMoney(json.event.min_cost);

    return clone;
}